<div class="anc-grid-wrap">
    <div class="anc-table-container">
        <div class="anc-table-scroll" [class.anc-table-scroll--has-detail]="!!rowDetailTemplate()">
            <table class="anc-table" [class.anc-table--widths-frozen]="hasFrozenWidths()">
                <thead>
                    <tr class="anc-thead-row">
                        @if (config()?.hasCheckbox) {
                            <th class="anc-th anc-th-check anc-th-sticky-left anc-sticky-edge-start">
                                <lib-anc-checkbox
                                    [ngModel]="allSelected()"
                                    [ngModelOptions]="{ standalone: true }"
                                    [indeterminate]="someSelected()"
                                    (changed)="toggleAllRows($event)"
                                ></lib-anc-checkbox>
                            </th>
                        }
                        @for (col of displayColumns(); track col.key) {
                            <th
                                class="anc-th"
                                [ngClass]="getColumnNgClass(col, 'anc-th')"
                                [style.insetInlineStart.px]="col.stickyLeft ? (config()?.hasCheckbox ? 48 : 0) : null"
                                [style.width]="getColumnWidth(col)"
                                [style.minWidth]="getColumnWidth(col)"
                                [attr.aria-sort]="getAriaSort(col)"
                            >
                                <span
                                    class="anc-th-inner"
                                    [class.anc-th-inner-sortable]="col.sortable"
                                    (click)="onSortClick(col)"
                                    (keydown.enter)="onSortClick(col)"
                                    (keydown.space)="onSortHeaderKeydown($any($event), col)"
                                    [attr.tabindex]="col.sortable ? 0 : null"
                                    [attr.role]="col.sortable ? 'button' : null"
                                >
                                    <span class="anc-th-label" translate>{{ col.label }}</span>
                                    @if (col.sortable) {
                                        <span
                                            class="anc-sort-icon"
                                            [class.anc-sort-icon--active]="getSortDirection(col) !== null"
                                            aria-hidden="true"
                                        >
                                            <!-- One IcoMoon glyph; rotate for ↑ so up/down never mix packs. -->
                                            <span
                                                class="icon icon--16 icon-chevron-down anc-sort-icon__glyph"
                                                [class.anc-sort-icon__glyph--up]="getSortDirection(col) !== 'asc'"
                                            ></span>
                                        </span>
                                    }
                                </span>
                            </th>
                        }
                    </tr>
                </thead>

                @if (loading()) {
                    <tbody>
                        @for (s of skeletonRows; track $index; let ri = $index) {
                            <tr class="anc-skeleton-row">
                                @if (config()?.hasCheckbox) {
                                    <td class="anc-td anc-td-check anc-td-sticky-left anc-sticky-edge-start">
                                        <div class="anc-shimmer anc-shimmer-sm"></div>
                                    </td>
                                }
                                @for (col of displayColumns(); track col.key; let ci = $index) {
                                    <td
                                        class="anc-td"
                                        [ngClass]="getColumnNgClass(col, 'anc-td')"
                                        [style.insetInlineStart.px]="col.stickyLeft ? (config()?.hasCheckbox ? 48 : 0) : null"
                                        [style.width]="getColumnWidth(col)"
                                        [style.minWidth]="getColumnWidth(col)"
                                    >
                                        @if (col.cellType === 'action') {
                                            <div class="anc-shimmer anc-shimmer-action"></div>
                                        } @else {
                                            <div class="anc-shimmer-cell">
                                                <div
                                                    class="anc-shimmer anc-shimmer-line"
                                                    [style.width]="shimmerPrimaryWidth(ri, ci)"
                                                ></div>
                                                <div
                                                    class="anc-shimmer anc-shimmer-line anc-shimmer-line--secondary"
                                                    [style.width]="shimmerSecondaryWidth(ri, ci)"
                                                ></div>
                                            </div>
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                } @else if (rows().length > 0) {
                    <tbody>
                        @for (row of sortedRows(); track trackById($index, row); let rowIndex = $index) {
                            <tr
                                class="anc-tr"
                                [class.anc-tr-selected]="isSelected(row)"
                            >
                                @if (config()?.hasCheckbox) {
                                    <td class="anc-td anc-td-check anc-td-sticky-left anc-sticky-edge-start">
                                        <lib-anc-checkbox
                                            [ngModel]="isSelected(row)"
                                            [ngModelOptions]="{ standalone: true }"
                                            (changed)="toggleRow(row, $event)"
                                        ></lib-anc-checkbox>
                                    </td>
                                }
                                @for (col of displayColumns(); track col.key) {
                                    <td
                                        class="anc-td"
                                        [ngClass]="getColumnNgClass(col, 'anc-td')"
                                        [style.insetInlineStart.px]="col.stickyLeft ? (config()?.hasCheckbox ? 48 : 0) : null"
                                        [style.width]="getColumnWidth(col)"
                                        [style.minWidth]="getColumnWidth(col)"
                                    >
                                        @if (col.cellType === 'action' && actionTemplate()) {
                                            <ng-container
                                                *ngTemplateOutlet="actionTemplate(); context: { $implicit: row, rowIndex: rowIndex, totalRows: sortedRows().length }"
                                            ></ng-container>
                                        } @else if (col.cellType === 'component') {
                                            <div
                                                class="anc-cell-with-copy"
                                                [class.anc-cell-with-copy--has-icon]="isColumnCopyable(col) && hasCopyValue(row, col)"
                                            >
                                                @if (getCellTemplate(col); as tpl) {
                                                    <ng-container
                                                        *ngTemplateOutlet="tpl; context: { $implicit: row, col: col }"
                                                    ></ng-container>
                                                }
                                                @if (isColumnCopyable(col) && hasCopyValue(row, col)) {
                                                    <button
                                                        type="button"
                                                        class="anc-copy-btn icon icon-copy custom-copy"
                                                        [attr.aria-label]="'Copy to clipboard'"
                                                        [title]="'Copy to clipboard'"
                                                        (click)="copyToClipboard(getCopyValue(row, col), $event)"
                                                    ></button>
                                                }
                                            </div>
                                            } @else if (col.renderMethod === 'productStock') {
                            <div class="d-flex align-items-center w-100 m-0">
                                <!-- ATP -->
                                <div class="d-flex flex-column align-items-start" style="flex: 1 1 0; min-width: 0;">
                                    <span style="color: var(--new-text-neutral-high-color, #282828); font-weight: 400; font-size: 14px; line-height: 22px;">
                                        {{ (row.attributes || row).product_stocks?.atp_stock != null ? (row.attributes
                                        || row).product_stocks.atp_stock : '0' }}
                                    </span>
                                    <span style="color: var(--text-positive-high-color, #006642); font-size: 12px; font-weight: 400; line-height: 16px;">
                                        {{ 'ATP' | translate }}
                                    </span>
                                </div>
                                <!-- Usable -->
                                <div class="d-flex flex-column align-items-start" style="flex: 1 1 0; min-width: 0;">
                                    <span style="color: var(--new-text-neutral-high-color, #282828); font-weight: 400; font-size: 14px; line-height: 22px;">
                                        {{ (row.attributes || row).product_stocks?.total_usable_quantity != null ?
                                        (row.attributes || row).product_stocks.total_usable_quantity : '-' }}
                                    </span>
                                    <span style="color: var(--text-positive-high-color, #006642); font-size: 12px; font-weight: 400; line-height: 16px;">
                                        {{ 'Usable' | translate }}
                                    </span>
                                </div>
                                <!-- In-Process -->
                                <div class="d-flex flex-column align-items-start" style="flex: 1 1 0; min-width: 0;">
                                    <span style="color: var(--new-text-neutral-high-color, #282828); font-weight: 400; font-size: 14px; line-height: 22px;">
                                        {{ (row.attributes || row).product_stocks?.total_inprocess_quantity != null ?
                                        (row.attributes || row).product_stocks.total_inprocess_quantity : '-' }}
                                    </span>
                                    <span style="color: var(--text-alert-medium-color, #9e6c00); font-size: 12px; font-weight: 400; line-height: 16px;">
                                        {{ 'In-Process' | translate }}
                                    </span>
                                </div>
                                <!-- Unusable -->
                                <div class="d-flex flex-column align-items-start" style="flex: 1 1 0; min-width: 0;">
                                    <span style="color: var(--new-text-neutral-high-color, #282828); font-weight: 400; font-size: 14px; line-height: 22px;">
                                        {{ (row.attributes || row).product_stocks?.total_unusable_quantity != null ?
                                        (row.attributes || row).product_stocks.total_unusable_quantity : '-' }}
                                    </span>
                                    <span style="color: var(--text-negative-high-color, #9f3500); font-size: 12px; font-weight: 400; line-height: 16px;">
                                        {{ 'Unusable' | translate }}
                                    </span>
                                </div>
                            </div>
                            } @else if (col.cellType === 'default' || !col.cellType) {
                                            <div
                                                class="anc-cell-with-copy"
                                                [class.anc-cell-with-copy--has-icon]="isColumnCopyable(col) && hasCopyValue(row, col)"
                                            >
                                                <div
                                                    class="anc-cell-text"
                                                    (click)="onCellTextClick($event, row, col)"
                                                    [libAncTooltip]="getCellTooltip(row, col) ?? ''"
                                                    [ancTooltipOnlyIfTruncated]="true"
                                                    [innerHTML]="getCellValue(row, col)"
                                                ></div>
                                                @if (isColumnCopyable(col) && hasCopyValue(row, col)) {
                                                    <button
                                                        type="button"
                                                        class="anc-copy-btn icon icon-copy custom-copy"
                                                        [attr.aria-label]="'Copy to clipboard'"
                                                        [title]="'Copy to clipboard'"
                                                        (click)="copyToClipboard(getCopyValue(row, col), $event)"
                                                    ></button>
                                                }
                                            </div>
                                        }
                                    </td>
                                }
                            </tr>
                            @if (rowDetailTemplate() && isRowExpanded(row)) {
                                <tr class="anc-tr anc-tr-detail">
                                    <td
                                        class="anc-td anc-td-detail"
                                        [attr.colspan]="detailColspan()"
                                    >
                                        <!-- Pinned to the visible part of the table (see scss). -->
                                        <div class="anc-td-detail__inner">
                                            <ng-container
                                                *ngTemplateOutlet="rowDetailTemplate(); context: { $implicit: row }"
                                            ></ng-container>
                                        </div>
                                    </td>
                                </tr>
                            }
                        }
                    </tbody>
                }
            </table>
        </div>

        @if (!loading() && noData()) {
            <div class="anc-empty">
                <div class="anc-empty-img">
                    <img
                        alt="no data"
                        [src]="config()?.emptyImageSrc || '/assets/images/search-icons-big.svg'"
                    />
                </div>
                <div class="anc-empty-text" translate>
                    {{ config()?.emptyMessage || 'No item present in this state' }}
                </div>
            </div>
        }
    </div>

    @if (showPagination()) {
        <div class="anc-footer">
            <lib-anc-pagination
                [currentPage]="currentPage()"
                [pageSize]="pageSize()"
                [totalCount]="totalCount()"
                [pageSizeOptions]="pageSizeOptions()"
                [disabled]="loading()"
                (pageChange)="pageChange.emit($event)"
                (pageSizeChange)="pageSizeChange.emit($event)"
            ></lib-anc-pagination>
        </div>
    }
</div>
